import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Kecheng = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73ca__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#c73ca__a)">
            <path
              fill="#F78644"
              d="M1.667 15V5.833c0-.92.746-1.666 1.666-1.666h13.334c.92 0 1.666.746 1.666 1.666V15c0 .92-.746 1.667-1.666 1.667H3.333c-.92 0-1.666-.747-1.666-1.667Z"
            />
            <path
              fill="#F78644"
              fillRule="evenodd"
              d="M1.042 5.833V15q0 .95.67 1.62.672.672 1.621.672h13.334q.949 0 1.62-.672.671-.67.671-1.62V5.833q0-.949-.67-1.62-.672-.671-1.621-.671H3.333q-.949 0-1.62.67-.671.672-.671 1.621Zm1.555 9.904q-.305-.306-.305-.737V5.833q0-.431.305-.736t.736-.305h13.334q.431 0 .736.305t.305.736V15q0 .431-.305.737-.305.305-.736.305H3.333q-.431 0-.736-.305Z"
            />
            <path
              fill="#F78644"
              fillRule="evenodd"
              d="M5.208 2.5v3.333a.625.625 0 1 0 1.25 0V2.5a.625.625 0 1 0-1.25 0Z"
            />
            <path
              fill="#FFF4E8"
              fillRule="evenodd"
              d="M10.417 8.958H5.833a.625.625 0 1 0 0 1.25h4.584a.625.625 0 1 0 0-1.25Zm3.75 3.334H5.833a.625.625 0 1 0 0 1.25h8.334a.625.625 0 1 0 0-1.25Z"
            />
            <path
              fill="#F78644"
              fillRule="evenodd"
              d="M13.542 2.5v3.333a.625.625 0 1 0 1.25 0V2.5a.625.625 0 1 0-1.25 0Z"
            />
          </g>
        </g>
      </svg>
    )
  }
)
